import React from "react";
import "./Testimonial.css";
import TripadvisorLogo from "../assets/images/TripadvisorLogo.png";
import circle from "../assets/images/circle.png";
import testiImage from "../assets/images/testiImage.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function Testimonial() {
  return (
    <div className="testimonial_outer">
      <div className="container-fluid">
        <div className="testimonial_section_tiles">
          <div className="tile_outer">
            <div className="title_logo">
              <img src={TripadvisorLogo} alt="Logo" className="img-fluid" />
            </div>
            <div className="slider_arrow"></div>
          </div>
        </div>
        <div className="testimonial_slider">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={0}
            slidesPerView={3}
            loop={true}
            autoplay={{ delay: 5000 }}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              0: {
                slidesPerView: 1, // mobile
              },
              576: {
                slidesPerView: 1, // small devices
              },
              768: {
                slidesPerView: 2, // tablet (md)
              },
              1024: {
                slidesPerView: 3, // laptop
              },
              1200: {
                slidesPerView: 3, // desktop
              },
            }}
          >
            <SwiperSlide>
              <div className="testimonial_card">
                <img src={circle} alt="Logo" className="img-fluid" />
                <h4>Great selection and service</h4>
                <p>
                  You've saved our business! Infinity Estate has got everything
                  I need. We were treated like royalty. It's really wonderful.
                </p>
                <div className="testiuser_outer">
                  <div className="testi_image">
                    <img src={testiImage} alt="Logo" className="img-fluid" />
                  </div>
                  <div className="testi_desc">
                    <h5>VasyaStamford_CT</h5>
                    <p>Philadelphia, Pennsylvania88 contributions</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial_card">
                <img src={circle} alt="Logo" className="img-fluid" />
                <h4>Great selection and service</h4>
                <p>
                  You've saved our business! Infinity Estate has got everything
                  I need. We were treated like royalty. It's really wonderful.
                </p>
                <div className="testiuser_outer">
                  <div className="testi_image">
                    <img src={testiImage} alt="Logo" className="img-fluid" />
                  </div>
                  <div className="testi_desc">
                    <h5>VasyaStamford_CT</h5>
                    <p>Philadelphia, Pennsylvania88 contributions</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial_card">
                <img src={circle} alt="Logo" className="img-fluid" />
                <h4>Great selection and service</h4>
                <p>
                  You've saved our business! Infinity Estate has got everything
                  I need. We were treated like royalty. It's really wonderful.
                </p>
                <div className="testiuser_outer">
                  <div className="testi_image">
                    <img src={testiImage} alt="Logo" className="img-fluid" />
                  </div>
                  <div className="testi_desc">
                    <h5>VasyaStamford_CT</h5>
                    <p>Philadelphia, Pennsylvania88 contributions</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial_card">
                <img src={circle} alt="Logo" className="img-fluid" />
                <h4>Great selection and service</h4>
                <p>
                  You've saved our business! Infinity Estate has got everything
                  I need. We were treated like royalty. It's really wonderful.
                </p>
                <div className="testiuser_outer">
                  <div className="testi_image">
                    <img src={testiImage} alt="Logo" className="img-fluid" />
                  </div>
                  <div className="testi_desc">
                    <h5>VasyaStamford_CT</h5>
                    <p>Philadelphia, Pennsylvania88 contributions</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
}
